// extracted by mini-css-extract-plugin
export var blue = "_2l-f";
export var brand = "_2l-b";
export var darkGrey = "_2l-e";
export var disabled = "_2l-4";
export var disabledSubtle = "_2l-5";
export var error = "_2l-6";
export var green = "_2l-g";
export var grey = "_2l-d";
export var icon = "_2l-0";
export var inherit = "_2l-a";
export var lightGrey = "_2l-c";
export var orange = "_2l-i";
export var pink = "_2l-k";
export var primary = "_2l-1";
export var purple = "_2l-l";
export var red = "_2l-j";
export var secondary = "_2l-2";
export var success = "_2l-9";
export var tertiary = "_2l-3";
export var warning = "_2l-7";
export var warningSecondary = "_2l-8";
export var white = "_2l-m";
export var yellow = "_2l-h";